<template>
  <div class="empty-container">
    <div class="empty-state">
      <font-awesome-icon :icon="icon" class="empty-icon" />
      <h3>{{ title }}</h3>
      <p>{{ message }}</p>
      <BaseButton v-if="actionRoute && actionText" :to="actionRoute" :icon="actionIcon">
        {{ actionText }}
      </BaseButton>
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import BaseButton from '@/components/shared/BaseButton.vue'

defineProps<{
  icon: string
  title: string
  message: string
  actionRoute?: string | Record<string, unknown>
  actionText?: string
  actionIcon?: string
}>()
</script>

<style scoped>
.empty-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1rem;
  text-align: center;
  background-color: white;
  border-radius: 0.75rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.empty-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
  color: #9ca3af;
}

.empty-state h3 {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: #1f2937;
}

.empty-state p {
  color: #6b7280;
  margin: 0 0 1rem 0;
  max-width: 500px;
}

</style>